import { httpClient } from '../../httpClient'

export type UserByArea = {
  id: string
  name: string
  image: string | null
  area: string | null
}

export type ListUsersByAreasParams = {
  areaIds?: string[]
}

export type ListUsersByAreasResponse = {
  value: string
  label: string
  avatar: string | null
  area: string | null
}[]

export async function listUsersByAreas({
  areaIds = [],
}: ListUsersByAreasParams): Promise<ListUsersByAreasResponse> {
  const { data } = await httpClient.get<UserByArea[]>(
    `/users/by-area?areaIds=${JSON.stringify(areaIds)}`,
  )

  return data.map((user) => ({
    value: user.id,
    label: user.name,
    avatar: user.image ?? null,
    area: user.area ?? null,
  }))
}
